import { AmountValue } from 'common/interfaces';
import { Currency, AccountMode } from 'enums';

export const initialValues: TransferData = {
  transferAll: false,
  selectedAccount: '',
  amount: {
    value: 0,
    currency: Currency.NONE
  },
  options: {
    ltipThresholdCzk: 0,
    ltipThresholdEur: 0,
    accountOptions: []
  }
};

export interface TransferData {
  transferAll: boolean;
  selectedAccount: string;
  amount: AmountValue;
  options: {
    ltipThresholdCzk: number;
    ltipThresholdEur: number;
    accountOptions: {
      mode: AccountMode;
      accountId: string;
      title: string;
    }[];
  };
}

export interface TransferTargetItem {
  orderId: string;
  from: 'K1' | 'K2' | 'K3' | 'CASH';
  to: 'K1' | 'K2' | 'K3' | 'CASH';
  target?: boolean;
  value?: AmountValue;
  enabled: boolean;
}

export interface TransferTargetData {
  accountTitle: string;
  targetAccountTitle: string;
  transferAll?: boolean;
  amount?: AmountValue;
  items: TransferTargetItem[];
}

export const initialValuesTarget: TransferTargetData = {
  accountTitle: '',
  targetAccountTitle: '',
  items: []
};
